import { render, staticRenderFns } from "./FormUserInfo.vue?vue&type=template&id=5bffd06f&"
import script from "./FormUserInfo.vue?vue&type=script&lang=js&"
export * from "./FormUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports